module.exports = __webpack_public_path__ + "static/media/Lulu.f869527e.png";